module.exports = __webpack_public_path__ + "static/media/Popup.cd5cdf53.png";